import { render, staticRenderFns } from "./AddBolInstruction.vue?vue&type=template&id=0a4f7f52&scoped=true"
import script from "./AddBolInstruction.vue?vue&type=script&lang=js"
export * from "./AddBolInstruction.vue?vue&type=script&lang=js"
import style0 from "./AddBolInstruction.vue?vue&type=style&index=0&id=0a4f7f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f7f52",
  null
  
)

export default component.exports